<template>
  <div style="height:100%;background:#ededed">
    <div class="contain hed100">
      <div class="nav-check-list"
           style="position: fixed;top:0;left: 0;z-index: 11;">
        <p class="ele-nav-checklist"
           :class="type==clueParam.allClue?selected:''"
           @click="changeType(clueParam.allClue)">全部<span class="line-nav-checklist"
                v-if="type==clueParam.allClue"></span></p>
        <p class="ele-nav-checklist"
           :class="type==clueParam.na?selected:''"
           @click="changeType(clueParam.na)">未联系<span class="line-nav-checklist"
                v-if="type==clueParam.na"></span></p>
        <p class="ele-nav-checklist"
           :class="type==clueParam.ing?selected:''"
           @click="changeType(clueParam.ing)">跟进中<span class="line-nav-checklist"
                v-if="type==clueParam.ing"></span></p>
        <p class="ele-nav-checklist"
           :class="type==clueParam.trans?selected:''"
           @click="changeType(clueParam.trans)">转销售<span class="line-nav-checklist"
                v-if="type==clueParam.trans"></span></p>
        <p class="ele-nav-checklist"
           :class="type==clueParam.close?selected:''"
           @click="changeType(clueParam.close)">关闭<span class="line-nav-checklist"
                v-if="type==clueParam.close"></span></p>
        <van-button plain
                    type="info"
                    style="width:1.54rem;height:0.54rem;padding:0.1rem;margin-left:0.14rem;margin-right:0.24rem;font-size:0.24rem"
                    @click="turnToHome">首页</van-button>
      </div>
      <scroller :on-infinite="infinite"
                :on-refresh="refresh"
                :noDataText="noDataText"
                ref="my_scroller"
                v-if="filterData.length>0">
        <div class="layout-checklist">
          <ClueItem :item="item"
                    v-for="item in filterData"
                    :key="item.id"></ClueItem>
        </div>
      </scroller>
      <div class="layout-checklist null-checklist"
           v-if="filterData.length==0">
        <img src="../../assets/images/img-null.png"
             class="img-null">
        <p class="color-gray">暂无数据</p>
      </div>
    </div>
    <div class="content-btn-check">
      <button class="del-desc-check btnCenter widthmax" @click="createNewClue">创建新线索</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import clueModel from '../../api/model/clue'
import ClueItem from '../../components/clue/ClueItem.vue'
export default {
  name: 'ClueList',
  data() {
    return {
      noDataText: '没有数据了',
      type: 0,
      clueArr: [],
      filterData: [],
      pageIndex: 1,
      pageSize: 20,
      selected: 'nac-nav-checklist',
    }
  },
  components: {
    ClueItem,
  },
  methods: {
    createNewClue(){
      this.$router.push('/clueInfo/0')
    },
    async getDataByType(type) {
      this.type = type
      const res = await clueModel.getCluePageList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: this.type,
      })
      if (res.success) {
        res.data.forEach((element) => {
          this.clueArr.push(element)
        })
        this.changeType(this.type)
      } else {
        this.$toast(res.msg)
      }
    },
    changeType(type) {
      this.type = type
      if (type != '') {
        this.filterData = this.clueArr.filter((p) => {
          return p.status == type
        })
      } else {
        this.filterData = this.clueArr
      }
    },
    infinite: function () {
      this.pageIndex++
      this.$refs.my_scroller.finishInfinite(false)
      this.getDataByType(this.type)
      this.$refs.my_scroller.finishInfinite(true)
    },
    refresh: function () {
      this.approveArr = []
      this.pageIndex = 1
      this.getDataByType(this.type)
      this.$refs.my_scroller.finishPullToRefresh()
    },
    turnToHome() {
      this.$router.push('/home')
    },
  },
  mounted() {
    this.getDataByType(this.clueParam.allClue)
  },
  computed: {
    ...mapState('systemAbout', ['clueParam']),
  },
}
</script>

<style scoped>

</style>